import { ReactNode } from 'react';
import { ReactComponent as MascotIcon } from '@assets/svg/mascot.svg';
import SolanaCoinImg from '@assets/png/solana-coin.png';
import SolanaCoinSmallImg from '@assets/png/solana-coin-small.png';
import SolanaCoinBlurredImg from '@assets/png/solana-coin-blurred.png';

interface IFloatingIconItem {
  icon: ReactNode | string;
  className: string;
}

const FLOATING_ICONS: IFloatingIconItem[] = [
  { icon: <MascotIcon />, className: 'mascot' },
  { icon: SolanaCoinSmallImg, className: 'sol-little' },
  { icon: SolanaCoinBlurredImg, className: 'sol-blurred' },
  { icon: SolanaCoinImg, className: 'sol-right' },
];

export default FLOATING_ICONS;
